module.exports = __webpack_public_path__ + "static/img/question.881829e9.png";